// Module
var code = "<template> <require from=\"./toolbar-group.scss\"></require> <slot></slot> </template> ";
// Exports
module.exports = code;